import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JgVisualInspReportFile } from '../models/jg/jg-visual-insp-report-file.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class JgVisualInspReportFileService extends RequestService<JgVisualInspReportFile> {
  static PATH = '/jg/visualInsp/reportFile';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService,
  ) {
    super(
      httpClient,
      JgVisualInspReportFileService.PATH,
      globalService.debugUrl,
    );
  }
}
